import { Pipe, PipeTransform } from '@angular/core';

import { TypeConverter } from '@personal-area/global/common';

@Pipe({
  name: 'moneyToNumber',
  standalone: true,
})
export class MoneyToNumberPipe implements PipeTransform {

  //TODO rename MoneyToNumberPipe to MoneyPipe
  transform(value: number | string, divider = 2, remainderLength = 2): string | number {
    if (value !== 0 && !value) {
      return value;
    }

    const val = typeof value === 'string' ? +value : value;

    if (isNaN(val)) {
      return value;
    }

    return TypeConverter.numberToMoney(val, divider, remainderLength);
  }

}
